import {Component} from '@angular/core';
import {ISignupWithPA} from "../../interfaces/ISignupWithPA";
import {IDistributor} from "../../interfaces/IDistributor";
import {User} from "../../services/User";
import {Locations} from "../../services/Locations";
import {Distributors} from "../../services/Distributors";
import {Session} from "../../services/Session";
import {Config} from "../../services/Config";
import {Notify} from "../../services/Notify";
import {Router, ActivatedRoute} from '@angular/router';
import {Helpers} from "../../services/Helpers";
import {ITheme} from "../../interfaces/ITheme";
import {UrlParser} from "../../services/UrlParser";

@Component({
  selector: 'enroll-page',
  templateUrl: 'enroll.html'
})
export class EnrollPageCmp {
  public step = 0;
  public lastReachedStep = 0;
  public signup = new ISignupWithPA();
  public name: string = '';
  public currentDate = '';
  public distributorsMap: { [id: number]: IDistributor } = {};
  public distributorsList: IDistributor[] = [];
  public distributorsSecondaryList: IDistributor[] = [];
  public saving = false;
  public loading = false;
  public isError = false;
  public errMsg = '';
  public notify;
  public lastStep = 8;
  public repName = '';
  public distr_id = 0;
  public secondary_distr_id = 0;
  public displayTosIsRequired: boolean = false;
  public displayThanks: boolean = false;
  public displayTos = true;
  public detailsEdit = false;
  public themeName = 'Purchase Clinic';
  public themeEmail = 'support@purchaseclinic.com';
  public themePhone = '877.659.2159';
  private defaultThemeName = 'Purchase Clinic';
  private defaultThemeEmail = 'support@purchaseclinic.com';
  private defaultThemePhone = '877.659.2159';
  private signupResponse: any;

  constructor(private users: User, private locations: Locations, private distributors: Distributors, private router: Router,
    public session: Session, private config: Config, private h: Helpers, public routeParams: ActivatedRoute, private urlParser: UrlParser) {
    let prelist = [];
    this.distributors.loadToList(prelist, () => {
      if (prelist && prelist.length) {
        this.distributorsList = [];
        prelist.forEach((d) => {
          if (d.survey_order > 0) {
            this.distributorsList.push(d);
          }
          if (d.survey_order_secondary > 0) {
            this.distributorsSecondaryList.push(d);
          }
        });
      }
    });
    this.distributors.loadToMap(this.distributorsMap);
    this.notify = new Notify();
    this.lastReachedStep = 0;
    this.setTheme(this.config.getThemeIDForHost());
  }

  setTheme(tID) {
    if (this.config.themesMap[tID]) {
      let theme: ITheme = this.config.themesMap[tID];
      if (theme.name) {
        this.defaultThemeName = theme.name;
      }
      this.themeName = this.defaultThemeName;

      if (theme.email_from_address || theme.contact_email) {
        this.defaultThemeEmail = theme.email_from_address || theme.contact_email;
      }
      this.themeEmail = this.defaultThemeEmail;

      if (theme.phone) {
        this.defaultThemePhone = theme.phone || this.defaultThemePhone;
      }
      this.themePhone = this.defaultThemePhone;
      if (this.signup && this.signup.user) {
        this.signup.user.theme_id = theme.id;
      }
      if (this.signup && this.signup.location) {
        this.signup.location.theme_id = theme.id;
      }
    }
  }

  ngOnInit() {
    try {
      let tags = this.urlParser.getParameter('tag_ids');
      if (tags) {
        let ids = tags.split(',');
        if (ids && ids.length) {
          let tag_ids = [];
          for (let id_s of ids) {
            let id = parseInt(id_s.trim());
            if (id > 0) {
              tag_ids.push(id);
            }
          }
          this.signup.tags = tag_ids;
        }
      }
    } catch (e) {}
    this.routeParams.params.subscribe(params => {
      let code = params['code'];
      if (code) {
        this.load(code);
      }
    });
    if (this.urlParser.getParameter('stos')) {
      this.displayTos = false;
    }
  }

  load(code) {
    if (!code || this.loading) {
      return false;
    }
    this.loading = true;
    this.users.getSignupCodeInfo(code).subscribe((info) => {
      if (info) {
        if (info.user?.id) {
          this.signup.user = info.user;
          this.name = [info.user.fname, info.user.lname].join(' ');
        }
        if (info.location?.id) {
          this.signup.location = info.location;
          if (info.location.__distributor_id) {
            this.distr_id = info.location.__distributor_id;
          }
          if (info.location.__distributor_secondary_id) {
            this.secondary_distr_id = info.location.__distributor_secondary_id;
          }
          if (info.location.__rep_fname || info.location.__rep_lname) {
            this.repName = [info.location.__rep_fname, info.location.__rep_lname].join(' ');
          }
        }
        this.step = 5;
        this.lastReachedStep = 5;
        if (info.location?.pa_date) {
          if (!this.distributorsList || !this.distributorsList.length) {
            setTimeout(() => {
              this.loading = false;
              this.nextStep();
            }, 500);
          } else {
            this.loading = false;
            this.nextStep();
          }
        } else {
          this.loading = false;
        }
      }
    }, () => {});
    this.users.getSignupCodeSession(code).subscribe((token) => {
      if (token) {
        this.setSessionToken(token);
      }
    }, () => {});
  }

  submit() {
    this.displayTosIsRequired = false;
    if (!this.signup.user.fname) {
      let n = this.name.trim();
      if (n.indexOf(' ') > -1) {
        this.signup.user.fname = n.substring(0, n.indexOf(' ')).trim();
        this.signup.user.lname = n.substring(n.indexOf(' ') + 1).trim();
      } else {
        this.signup.user.fname = n;
      }
    }
    if (!this.signup.user.email) {
      this.notify.error('Sorry, field Email is required');
      this.step = 0;
      return;
    }
    if (this.signup.user.email.indexOf('@') < 1 || this.signup.user.email.length < 6) {
      this.notify.error('Please double-check the email address that you entered. There appears to be a typo.');
      this.step = 0;
      return;
    }
    let theme_id = this.config.getThemeIDForHost();
    this.signup.user.theme_id = theme_id;
    this.signup.location.theme_id = theme_id;
    if (theme_id == this.config.defaultThemeID) {
      this.signup.to_generate_rx = true;
    }
    this.signup.signature = '--electronic signature--';
    this.signupResponse = null;
    this.saving = true;
    this.isError = false;
    this.users.signupWithPA(this.signup).subscribe((response) => {
      this.signupResponse = response;
      this.saving = false;
      this.session.signupUrl = window.location.hostname + window.location.pathname;
      if (response?.token) {
        this.setSessionToken(response.token);
      }
      this.nextStep();
    }, (response) => {
      this.step = 0;
      this.isError = true;
      this.saving = false;
      console.error(response);
      if (response && response.status) {
        switch (response.status) {
          case 417:
            this.errMsg = 'Please double-check the name that you entered. There appears to be a typo.';
            break;
          case 409:
            this.errMsg = 'User with this email is already registered';
            break;
          case 406:
            this.errMsg = 'Please double-check the email address that you entered. There appears to be a typo.';
            break;
          case 400:
            this.errMsg = 'Please fill required fields.';
            break;
          case 418:
            this.errMsg = 'Please double-check the phone number that you entered. There appears to be a typo.';
            break;
          case 419:
            this.errMsg = 'Please double-check the zip code that you entered. There appears to be a typo.';
            this.signup.user.zip = null;
            break;
          default:
            this.errMsg = '';
        }
        if (this.errMsg) {
          this.notify.error(this.errMsg);
        }
      }
    });
  }

  nextStepUI() {
    if (this.isNextStepDisabled()) {
      return;
    }
    this.nextStep();
  }

  nextStep() {
    if ((this.step - 0) === this.lastStep) {
      this.lastStepRedirect();
    } else {
      let next = (this.step - 0) + 1;
      if (next === 6 && (!this.distributorsList || !this.distributorsList.length)) {
        next = 7;
      }
      if (next === 7 && (!this.distributorsList || !this.distributorsList.length)) {
        next = 8;
      }
      this.step = next;
      if (this.lastReachedStep < this.step) {
        this.lastReachedStep = this.step;
      }
    }
  }

  isNextStepDisabled() {
    switch (this.step) {
      case 0: // email
        if (!this.signup?.user?.email || (this.signup?.user?.email?.indexOf('@') < 0)) {
          return true;
        }
        break;
      case 1: // name
        return false;
      case 2: // facility name
        return false;
      case 3: // phone
        return false;
      case 4: // zip
        return false;
      case 5: // TOS
        return true;
      case 6: // prim distr
        return false;
      case 7: // second distr
        return false;
      case 8: // rep
        return false;
      default:
        return false;
    }
    return false;
  }

  prevStep() {
    let prev = this.step - 1;
    if (prev < 0) {
      return;
    }
    this.step = prev;
  }

  lastStepRedirect() {
    let token = this.session.getToken();
    if (!token) {
      if (this.signupResponse && this.signupResponse.token) {
        token = this.signupResponse.token;
        this.setSessionToken(token, () => {
          this.sendAdditionalQuestionsAndRedirect(token);
        }, () => {
          this.redirects();
        });
      } else {
        this.redirects();
      }
    } else {
      this.sendAdditionalQuestionsAndRedirect(token);
    }
  }

  sendAdditionalQuestionsAndRedirect(token) {
    if (this.signup.location?.id && token && (this.distr_id || this.secondary_distr_id)) {
      this.locations.sendMiniSurvey({
        distributor_id: this.distr_id,
        secondary_distributor_id: this.secondary_distr_id,
        rep_name: this.repName,
        loc_id: this.signup.location.id
      }, token).subscribe(() => {
        this.redirects(token);
      }, () => {
        this.redirects(token);
      });
    } else {
      this.redirects(token);
    }
  }

  redirects(token?: string) {
    let theme_id = this.config.getThemeIDForHost();
    if (token) {
      // if (theme_id == this.config.defaultThemeID && this.signupResponse && this.signupResponse.rx_code) {
      //   this.router.navigateByUrl(`/new_member?msg_id=1&code=${token}&ask_vac=1&rx=${this.signupResponse.rx_code}`);
      // } else {
      //   this.router.navigate(['/signup_benefit_review']);
      // }
      this.displayThanks = true;
    } else {
      this.router.navigate(['/login']);
    }
  }

  setSessionToken(token, cb?, errCb?) {
    this.session.setToken(token, () => {
      if (!this.signup.location?.id && this.session?.user?.__location?.id) {
        this.signup.location = this.session.user.__location;
      }
      if (this.session.user?.id && this.signup.user && !this.signup.user.id) {
        this.signup.user.id = this.session.user.id;
      }
      if (cb) {
        cb();
      }
    }, errCb, true);
  }

  getProgressPercent() {
    if (this.lastReachedStep < 1 || this.lastStep < 0) {
      return 0;
    }
    return Math.round((this.lastReachedStep / (this.lastStep + 1)) * 100);
  }
}
